import { render, staticRenderFns } from "./ResourceBookingForm.vue?vue&type=template&id=2478fceb&scoped=true"
import script from "./ResourceBookingForm.vue?vue&type=script&lang=js"
export * from "./ResourceBookingForm.vue?vue&type=script&lang=js"
import style0 from "./ResourceBookingForm.vue?vue&type=style&index=0&id=2478fceb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2478fceb",
  null
  
)

export default component.exports